import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGroupQRRequestData, setGroupQRResponseData } from "../../../../../_reducers/DataPanel/Sales/transfersSlice";
import { Button, Col, Row, Spinner, Accordion } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "../../../../primer/Pagination";
import moment from "moment";
import { isEmpty } from "../../../../../_helpers/commonFunctions";
import DateHelper from "../../../../primer/DateHelper/DateHelper";
import DateBox from "../../../../primer/DateBox";
import GroupQRModal from "./GroupQRModal";

const GeneratedGroupQRs = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.TRANSFERS.generatedQrsRequestData);
    const responseData = useSelector((state) => state.TRANSFERS.generatedQrsResponseData);
    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showQRModal, setShowQRModal] = useState(false);
    const [selectedGroupData, setSelectedGroupData] = useState(null);
    const [accordionOpen, setSTAccordionOpen] = useState(true);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(false, true);
        }
    }, [pageChanged]);

    useEffect(() => {
        const initialReqData = {
            ...requestData,
            dateFrom: "",
            dateTo: ""
        };

        dispatch(setGroupQRRequestData(initialReqData));
        fetchReport(false, initialReqData);
    }, []);

    const fetchReport = (fromPagination = false, isInitialLoad = false) => {
        setLoading(true);
        if (!fromPagination && !isInitialLoad) {
            setSTAccordionOpen(false);
        }

        const reqData = { ...requestData };
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setGroupQRRequestData(reqData));
        }

        const payload = {
            ...reqData,
            company: company.id,
            dateFrom: reqData.dateFrom ? moment(reqData.dateFrom, "DD/MM/YYYY").startOf("day").format() : null,
            dateTo: reqData.dateTo ? moment(reqData.dateTo, "DD/MM/YYYY").endOf("day").format() : null,
        };

        axios.post(`${process.env.REACT_APP_API_URL2}/sale/list-group-qrs`, payload)
            .then((res) => {
                if (res.data.status === "200") {
                    const newData = res.data.data || [];
                    dispatch(setGroupQRResponseData({
                        ...responseData,
                        data: newData,
                        totalItems: res.data.totalItems || 0,
                        totalPages: res.data.totalPages || 0,
                    }));
                    if (!fromPagination && !isInitialLoad) {
                        if (res.data.data.length > 0) {
                            toast.success("Επιτυχής ανανέωση.", {autoClose: 1000});
                        } else {
                            toast.info("Επιτυχής ανανέωση, δεν βρέθηκαν δεδομένα.", {autoClose: 2000});
                        }
                    }
                } else {
                    dispatch(setGroupQRResponseData({...responseData, data: [], totalItems: 0, totalPages: 0}));
                    toast.error(res.data.message || "Σφάλμα κατά την αναζήτηση.");
                }
            }).catch((err) => {
            console.error(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        });
    };

    const onPageChange = (page) => {
        setPageChanged(true);
        dispatch(setGroupQRRequestData({ ...requestData, page }));
    };

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        }
        dispatch(setGroupQRRequestData({ ...requestData, ...prepChange }));
    };

    const handleAccordionClick = () => {
        setSTAccordionOpen(!accordionOpen);
    };

    return (
        <div>
            <div onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Accordion activeKey={accordionOpen === true ? "0" : ""} className={"mb-2 custom-accordion"}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header onClick={(e) => handleAccordionClick(e)}>{"Φίλτρα"}</Accordion.Header>
                        <Accordion.Body>
                            <Row className={"mb-3 align-items-end"}>
                                <Col md={3}>
                                    <DateHelper
                                        dateFromAndToFunction={(from, to) => {
                                            dispatch(setGroupQRRequestData({
                                                ...requestData,
                                                dateFrom: from,
                                                dateTo: to
                                            }));
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <DateBox
                                        name={"dateFrom"}
                                        selected={isEmpty(requestData?.dateFrom) ? null : moment(requestData.dateFrom, "DD/MM/YYYY").toDate()}
                                        label={"Ημερομηνία Λήξης Από"}
                                        onChange={(e) => handleOnChange(e, "datebox", "dateFrom")}
                                        allowOtherYears={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <DateBox
                                        name={"dateTo"}
                                        selected={isEmpty(requestData?.dateTo) ? null : moment(requestData.dateTo, "DD/MM/YYYY").toDate()}
                                        label={"Ημερομηνία Λήξης Έως"}
                                        onChange={(e) => handleOnChange(e, "datebox", "dateTo")}
                                        allowOtherYears={true}
                                    />
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Row>
                    <Col md={12} className={"d-flex justify-content-end mb-3"}>
                        <Button style={{maxHeight: "45px"}} onClick={() => fetchReport(false)} disabled={loading}>
                            Εφαρμογή φίλτρων {loading &&
                            <Spinner className={"ml-2"} animation={"border"} variant={"light"} size="sm"/>}
                        </Button>
                    </Col>
                </Row>
            </div>

            {responseData?.totalPages > 0 && (
                <React.Fragment>
                    <Row className={"mb-2"}>
                        <Col md={12} className="d-flex flex-column flex-md-row justify-content-end align-items-center align-items-md-start">
                            <div className="mr-md-3 mt-2 mb-2 mb-md-0 text-center text-md-right">
                                <i style={{ whiteSpace: 'nowrap' }}>
                                    Σύνολο Αποτελεσμάτων: {responseData.totalItems}
                                </i>
                            </div>
                            <div className="d-flex justify-content-center justify-content-md-end">
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(e) => onPageChange(e)}
                                    maxWidth={400}
                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <table className={"transfers-table responsive-table"}>
                                <thead>
                                <tr>
                                    <th>A/A</th>
                                    <th>Group ID</th>
                                    <th>Πλήθος QR URLs</th>
                                    <th>Ημερομηνία Λήξης</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((item, idx) => {
                                    const perPage = 10;
                                    const rowNumber = ((requestData.page || 1) - 1) * perPage + idx + 1;

                                    return (
                                        <tr
                                            key={item._id || `qr-group-${idx}`}
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedGroupData(item);
                                                setShowQRModal(true);
                                            }}
                                            title="Προβολή Ομαδικού Κωδικού QR"
                                        >
                                            <td data-label="A/A">{rowNumber}</td>
                                            <td data-label="ID">
                                                {item.groupId}
                                            </td>
                                            <td data-label="Πλήθος QR URLs">
                                                {item.qrUrls?.length || 0}
                                            </td>
                                            <td data-label="Ημερομηνία Λήξης">
                                                {item.expiresAt
                                                    ? moment(item.expiresAt).format("DD/MM/YYYY HH:mm")
                                                    : "-"
                                                }
                                            </td>
                                            <td
                                                className="d-none d-md-table-cell"
                                                style={{
                                                    verticalAlign: "middle",
                                                    textAlign: "center",
                                                    padding: "3px",
                                                    color: "#76aeb7",
                                                    fontSize: "1.2rem"
                                                }}
                                            >
                                                <i className="fa-solid fa-qrcode"></i>
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>

                    {selectedGroupData !== null && (
                        <GroupQRModal
                            show={showQRModal}
                            setShow={setShowQRModal}
                            groupData={selectedGroupData}
                            message={false}
                        />
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

export default GeneratedGroupQRs;